<div class="dialog">
  <h2 mat-dialog-title class="header">
    {{ 'event_steps.step_location.similar_events_dialog.title' | translate }}
    <button class="close-ref" mat-icon-button (click)="closeAndCancel()" [title]="'general.close' | translate | titlecase">
      <mat-icon>clear</mat-icon>
    </button>
  </h2>
  @if (!!data && data.length > 0) {
    <div class="profile-content" mat-dialog-content>
      <div class="similar-content" [innerHTML]="'event_steps.step_location.similar_events_dialog.explain_text' | translate"></div>
      <div class="overview-scroll-content">
        @for (item of data; track item) {
          <overview-card-old [event]="item" [navigateToEventOnClick]="false" (click)="closeWithLinking(item)" [title]="'Koppel aan dit event'"></overview-card-old>
        }
      </div>
    </div>
  }
  <div mat-dialog-actions class="dialog-buttons">
    <button mat-stroked-button (click)="closeAndCancel()" [title]="'general.cancel' | translate | titlecase">
      {{ 'general.cancel' | translate }}
    </button>
    <button class="close-ref" mat-flat-button (click)="closeWithoutLinking()" [color]="'primary'" [title]="'event_steps.step_location.similar_events_dialog.new_event' | translate">
      {{ 'event_steps.step_location.similar_events_dialog.new_event' | translate }}
    </button>
  </div>
</div>
